// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2Ter_","approved":"Status_approved__1HTa-","rejected":"Status_rejected__2WnIp","expired":"Status_expired__1bBLv","label":"Status_label__3FPDF"};